import { memoize } from 'lodash';
import { TFunction } from '@app/components/translation';

export const getAutomationRulesKeyMessageMap = memoize((t: TFunction): Record<string, string> => {
  return {
    agreement_empty_trash: t('Permanently delete documents in trash', {
      _comment: 'Used as the name of the automation rule',
    }),
    agreement_expired_trash: t('Move overdue documents to trash', {
      _comment: 'Used as the name of the automation rule',
    }),
    agreement_terminated_trash: t('Move terminated documents to trash', {
      _comment: 'Used as the name of the automation rule',
    }),
    agreement_declined_trash: t('Move declined documents to trash', {
      _comment: 'Used as the name of the automation rule',
    }),
    agreement_draft_trash: t('Move draft documents to trash', {
      _comment: 'Used as the name of the automation rule',
    }),
    agreement_signed_trash: t('Move signed documents to trash', {
      _comment: 'Used as the name of the automation rule',
    }),
  };
});
